import { render, staticRenderFns } from "./Errorpage.vue?vue&type=template&id=5afdf15b&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Errorpage.vue"
export default component.exports